<?xml version="1.0" encoding="UTF-8"?>
<svg width="92" height="88" version="1.1" viewBox="0 0 92 88" xmlns="http://www.w3.org/2000/svg">
 <g fill="none" fill-rule="evenodd">
  <path d="M1.125 1.125h89.75v85.75H1.125z" fill="#FFF" stroke="#D9DDDF" stroke-width="2.25"/>
  <path d="M21 43.356l50.568.5" stroke="#0069C4" stroke-linecap="square" stroke-width="2.5"/>
 </g>
 <path d="m78.699 35.802-0.21217 16.527-14.207-8.4474z" fill="#0069c4"/>
</svg>
